import React from 'react';
import { X } from 'lucide-react';
import { useTranslation } from '../../hooks/useTranslation';

interface FriendIdTooltipProps {
  onClose?: () => void;
}

export function FriendIdTooltip({ onClose }: FriendIdTooltipProps) {
  const { t } = useTranslation();
  
  return (
    <div className="absolute z-10 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 p-4">
      <div className="flex items-start justify-between">
        <h3 className="text-sm font-medium text-gray-900">{t('profile.friend_code.where_to_find')}</h3>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="ml-4 text-gray-400 hover:text-gray-500"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
      <div className="mt-2">
        <p className="text-sm text-gray-600">
          {t('profile.friend_code.tooltip_info')}
        </p>
      </div>
    </div>
  );
}